import { c as _c } from "react/compiler-runtime";
import { PortableText } from "@portabletext/react";
import { NavLink } from "../../../shared/components/Navbar/Navbar";
import { Contributor, ContributorType } from "../Contributors/Contributor";
import { LinkComponent, LinkType, getHref } from "../Links/Links";
import styles from "./PhilantropicTeaser.module.scss";
import LinkButton from "../../../shared/components/EffektButton/LinkButton";
import { useRouterContext } from "../../../../context/RouterContext";

/* Two columns inside the right half of a two-column grid; one column of two on mobile */
const PEOPLE_SIZES = "(min-width: 1920px) 354px, (min-width: 1521px) calc(22.5vw - 75px), (min-width: 1181px) calc(22.5vw - 60px), calc(45vw - 8px)";
export const PhilantropicTeaser: React.FC<{
  title: string;
  description: any[];
  links: (LinkType | NavLink)[];
  button: {
    text: string;
    link: NavLink;
  };
  people: ContributorType[];
  locale?: string;
}> = t0 => {
  const $ = _c(29);
  const {
    title,
    description,
    links,
    button,
    people,
    locale
  } = t0;
  const {
    articlesPagePath,
    fundraisersPath
  } = useRouterContext();
  let t1;
  if ($[0] !== title) {
    t1 = <h3>{title}</h3>;
    $[0] = title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== description) {
    t2 = description || [];
    $[2] = description;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <div className={styles.text}><PortableText value={t2} /></div>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== links) {
    t4 = links && links.map(_temp);
    $[6] = links;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t4) {
    t5 = <div className={styles.links}>{t4}</div>;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== articlesPagePath || $[11] !== button || $[12] !== fundraisersPath) {
    t6 = button && button.text && button.link && (() => {
      const {
        href,
        isFundraiser
      } = getHref(button.link, articlesPagePath, fundraisersPath);
      return <div className={styles.button}><LinkButton url={href} title={button.text} type="primary" prefetch={isFundraiser ? false : undefined} /></div>;
    })();
    $[10] = articlesPagePath;
    $[11] = button;
    $[12] = fundraisersPath;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t1 || $[15] !== t3 || $[16] !== t5 || $[17] !== t6) {
    t7 = <div className={styles.description}>{t1}{t3}{t5}{t6}</div>;
    $[14] = t1;
    $[15] = t3;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== locale || $[20] !== people) {
    let t9;
    if ($[22] !== locale) {
      t9 = person => <Contributor {...person} key={person._id} locale={locale} sizes={PEOPLE_SIZES} contactLink={true} />;
      $[22] = locale;
      $[23] = t9;
    } else {
      t9 = $[23];
    }
    t8 = people.map(t9);
    $[19] = locale;
    $[20] = people;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[24] !== t8) {
    t9 = <div className={styles.people}>{t8}</div>;
    $[24] = t8;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  let t10;
  if ($[26] !== t7 || $[27] !== t9) {
    t10 = <div className={styles.container}>{t7}{t9}</div>;
    $[26] = t7;
    $[27] = t9;
    $[28] = t10;
  } else {
    t10 = $[28];
  }
  return t10;
};
function _temp(link) {
  return <LinkComponent link={link} key={link._key} />;
}